import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import * as api from "../lib/api";
import { toast } from "sonner";
import { Toaster } from "../components/ui/sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = match[1];
    (async () => {
      try {
        const u = await api.googleCallback(session_id);
        setUser(u);
        // Strip the hash and go to app
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/app", { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed", { description: e.message });
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
      <Toaster position="top-center" richColors />
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#10B981] mx-auto" />
        <p className="mt-3 font-figtree text-sm text-[#64748B]">
          Signing you in…
        </p>
      </div>
    </div>
  );
}
